import React from 'react';

import { ModelSchema } from '../ModelSchema';
import { PropertySchema } from '../PropertySchema';

export interface PropertyComponentConfiguration {
  disabled: boolean;
}

export interface PropertyComponentProps<TValue, TCustomConfiguration = {}> {
  name: string;
  value: TValue;

  schema: PropertySchema<TValue, TCustomConfiguration>;

  configuration: PropertyComponentConfiguration;

  onEdit: (newValue: TValue) => void;
}

export type ModelEditedHandler<TModel> = (guid: string, editedProperties: Partial<TModel>) => void;

export interface ModelPropertyProps<TModel> {
  readonly model: TModel;
  readonly onEdit: ModelEditedHandler<TModel>;
  readonly modelSchema: ModelSchema<TModel>;
  readonly property: keyof TModel & string;
  readonly disabled?: boolean;
}

export function ModelProperty<TModel>({ model, onEdit, modelSchema, property, disabled }: ModelPropertyProps<TModel>) {
  const propertySchema = modelSchema.properties[property];
  if (propertySchema == null) {
    throw new Error(`Schema for ${modelSchema.pluralDisplayName} has no property named ${property}`);
  }

  const displayName = propertySchema.configuration.displayName ?? property;

  return (
    <>
      {React.createElement(propertySchema.component, {
        name: displayName,

        value: model[property],
        schema: propertySchema,

        configuration: {
          disabled: disabled === true,
        },

        onEdit(newValue: any) {
          onEdit((model as { guid: string }).guid, { [property]: newValue } as Partial<TModel>);
        },
      })}
    </>
  );
}
